import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import BreakpointUp from "../Media/BreakpointUp"
import MapPointer from "../Icons/MapPointer"
import PhoneIcon from "../Icons/PhoneIcon"
import EmailIcon from "../Icons/EmailIcon"
import DropIcon from "../Icons/DropIcon"
import IndustryFooterMenu from "./IndustryFooterMenu"
import RepairServiceFooterMenu from "./RepairServiceFooterMenu"
import AboutFooterMenu from "./AboutFooterMenu"
import KnowledgeHubFooterMenu from "./KnowledgeHubFooterMenu"
import OtherLinksFooterMenu from "./OtherLinksFooterMenu"
import Social from "../Social"

const Wrap = styled.div`
  background: #f5f5f5;
  padding: 55px 0 25px;
  border-top: 1px solid #dedede;
  @media (max-width: 1024px) {
    padding: 25px 0;
  }
`
const MenuGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, auto);
  justify-content: space-between;
  & br {
    line-height: 34px;
  }
  & strong {
    line-height: 34px;
    color: #333333;
    font-size: 16px;
    font-weight: 600;
  }
  & a {
    display: block;
    width: 100%;
    max-width: 230px;
    font-size: 16px;
    line-height: 32px;
    color: #666666;
    &:hover {
      text-decoration: underline !important;
      color: #0059b2;
    }
  }
  @media (max-width: 1024px) {
    display: none;
  }
`
const MobileFooter = styled.div`
  display: none;
  @media (max-width: 1024px) {
    display: block;
  }
`
const IconMenuItem = styled.div`
  display: flex;
  align-items:center;
  & .icon {
    display: flex;
    align-items:center;
    > svg{
      width: 20px;
    }
    + .text{
      margin-left:5px;
    }
  }
  & a {
    color: #666;
    &:hover{
      color:#000;
    }
  }
  @media (max-width: 1024px) {
    margin-top: 10px;
    margin-right: 20px;
    width: 250px;
  }
`
const Divider = styled.div`
  width: 100%;
  border-top: 1px solid #dedede;
  margin: 55px 0 25px;
  @media (max-width: 1024px) {
    margin-top: 37px;
  }
  @media (max-width: 480px) {
    margin-top: 25px;
  }
`
const FooterBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 -15px;
  text-align: center;
  flex-direction: column;
  @media (min-width: 576px) {
    justify-content: space-between;
    flex-direction: row;
  }
`
const CopyRight = styled.div`
  color: #666;
  position: relative;
  width: 100%;
  padding: 0 15px;
  font-size: 14px;
  line-height: 28px;
  text-align:center;
  @media (min-width: 576px) {
      text-align:right;
  }
  ${BreakpointUp.md`
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  `}
  ${BreakpointUp.xl`
    font-size: 16px;
    line-height: 34px;
  `}
`
const Brands = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 0 15px;
  /* max-width: 720px; */
  margin: 0 -5px;
  @media (min-width: 576px) {
    justify-content: start;
    margin: 0 -10px;
  }
  ${BreakpointUp.xl`
  margin:0 -20px;
  `}
`
const BrandIeam = styled.div`
  position: relative;
  padding: 0 5px;
  @media (min-width: 576px) {
    padding: 0 10px;
  }
  /* ${BreakpointUp.md`
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  `} */
  ${BreakpointUp.xl`
    padding:0 20px;
  `}
  .gatsby-image-wrapper {
    > div {
      max-width: 100% !important;
    }
    & img {
      filter: gray;
      -webkit-filter: grayscale(1);
      filter: grayscale(1);
    }

    & picture {
      img {
          opacity: ${props => props.imgOpacity} !important;  
      }
    }
  }
`


const DropWrapp = styled.div`
  margin-top: 0px;
  cursor: pointer;
  padding: 20px 0px;
  border-bottom: 1px solid #dedede;
  @media (max-width: 480px) {
    padding: 10px 15px;
  }
`
const DropButton = styled.div`
  margin-top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 480px) {
    font-size: 20px;
  }
`
const DropButtonText = styled.div`
  width: calc(100% - 30px);
  font-size: 16px;
  line-height: 34px;
  font-family: 'UniNeueBold', sans-serif;
  font-weight: 700;
  text-align: left;
  color: #000000;
`
const DropButtonImg = styled.div`
  width: 30px;
  display: inline-block;
  & svg {
    float: right;
    transform: ${(props) => (props.isVisible ? "rotate(180deg)" : "none")};
    transition: all 0.3s ease;
  }
`
const FadeContent = styled.div`
  display: ${(props) => (props.isVisible ? "grid" : "none")};
  padding-right: 20px;
  margin-top: 15px;
  grid-row-gap: 10px;
  
  ${BreakpointUp.md`
    grid-template-columns: repeat(2, auto);    
  `}
  ${BreakpointUp.lg`
    grid-template-columns: repeat(3, auto);
    justify-content: space-between;
  `}
  ${BreakpointUp.xl`
    grid-template-columns: repeat(4, auto);
  `}
  & a {
    color: #666;
  }
  & p {
    margin-bottom: 10px;
  }
`
const MobileInfo = styled.div`
  display: none;
  @media (max-width: 1024px) {
    margin-top: 20px;
    display: flex;
    & strong {
      font-size: 16px;
      font-family: 'UniNeueBold', sans-serif;
      font-weight: 700;
      line-height: 24px;
      color: #000;
    }
  }
  @media (max-width: 480px) {
    display: block;
    & .address {
      padding: 0 15px;
    }
    & .social {
      margin-top: 20px;
      padding: 0 15px;
    }
  }
`
class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      industryVisible: false,
      repairVisible: false,
      aboutVisible: false,
      knowledgeVisible: false,
    }
    this.handleFadeIndustry = this.handleFadeIndustry.bind(this)
    this.handleFadeRepair = this.handleFadeRepair.bind(this)
    this.handleFadeAbout = this.handleFadeAbout.bind(this)
    this.handleFadeKnowledge = this.handleFadeKnowledge.bind(this)
  }
  handleFadeIndustry() {
    const nextState = !this.state.industryVisible
    this.setState({
      industryVisible: nextState,
      repairVisible: false,
      aboutVisible: false,
      knowledgeVisible: false,      
    })
  }
  handleFadeRepair() {
    const nextState = !this.state.repairVisible
    this.setState({
      industryVisible: false,
      repairVisible: nextState,
      aboutVisible: false,
      knowledgeVisible: false,
    })
  }
  handleFadeAbout() {
    const nextState = !this.state.aboutVisible
    this.setState({
      industryVisible: false,
      repairVisible: false,
      aboutVisible: nextState,
      knowledgeVisible: false,
    })
  }
  handleFadeKnowledge() {
    const nextState = !this.state.knowledgeVisible
    this.setState({
      industryVisible: false,
      repairVisible: false,
      aboutVisible: false,
      knowledgeVisible: nextState,
    })
  }
  
  render() {
    const {
      industryVisible,
      repairVisible,
      aboutVisible,
      knowledgeVisible,
    } = this.state
    return (
      <Wrap>
        <div className="container">
          <MenuGrid>
            <div>
              <strong>Industries We Serve!</strong>
              <IndustryFooterMenu />
            </div>            
            <div>
              <strong>Repair Service</strong>
              <RepairServiceFooterMenu />
              <br />
              <strong>About AES</strong>
              <AboutFooterMenu />
            </div>
            <div>
              <strong>Knowledge Hub</strong>
              <KnowledgeHubFooterMenu />
              <br />
              <br />
              <br />
              <strong>Other Links</strong>
              <OtherLinksFooterMenu />
            </div>
            <div>
              <strong>Repair Facilities Locations</strong>
              <IconMenuItem>
                <span className="icon"><MapPointer /></span>
                <span className="text">101 Technology Lane. Mt. Airy, NC 27030</span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><MapPointer /></span>
                <span className="text">2875 N. Berkeley Lake Rd, Suite 1 Duluth GA 30096</span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><MapPointer /></span>
                <span className="text">101 Memorial Drive Suite 103 Chattanooga, TN, 37415</span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><PhoneIcon /></span>
                <span className="text"><a href="tel:8663861001">1866-386-1001</a></span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><EmailIcon /></span>
                <span className="text"><a href="mailto:sales@aesintl.com">sales@aesintl.com</a></span>
              </IconMenuItem>
              <br />
              <br />
              <strong>Connect with us</strong>
              <Social />
            </div>
          </MenuGrid>
        </div>
        <MobileFooter>
          <div className="container">
            <DropWrapp>
              <DropButton
                onClick={this.handleFadeIndustry}
                isVisible={industryVisible}
              >
                <DropButtonText>Industries We Serve!</DropButtonText>
                <DropButtonImg isVisible={industryVisible}>
                  <DropIcon />
                </DropButtonImg>
              </DropButton>
              <FadeContent isVisible={industryVisible}>
                <IndustryFooterMenu />
              </FadeContent>
            </DropWrapp>
            <DropWrapp>
              <DropButton
                onClick={this.handleFadeRepair}
                isVisible={repairVisible}
              >
                <DropButtonText>Repair Service</DropButtonText>
                <DropButtonImg isVisible={repairVisible}>
                  <DropIcon />
                </DropButtonImg>
              </DropButton>
              <FadeContent isVisible={repairVisible}>
                <RepairServiceFooterMenu />
              </FadeContent>
            </DropWrapp>
            <DropWrapp>
              <DropButton
                onClick={this.handleFadeAbout}
                isVisible={aboutVisible}
              >
                <DropButtonText>About AES</DropButtonText>
                <DropButtonImg isVisible={aboutVisible}>
                  <DropIcon />
                </DropButtonImg>
              </DropButton>
              <FadeContent isVisible={aboutVisible}>
                <AboutFooterMenu />
              </FadeContent>
            </DropWrapp>
            <DropWrapp>
              <DropButton
                onClick={this.handleFadeKnowledge}
                isVisible={knowledgeVisible}
              >
                <DropButtonText>Knowledge Hub</DropButtonText>
                <DropButtonImg isVisible={knowledgeVisible}>
                  <DropIcon />
                </DropButtonImg>
              </DropButton>
              <FadeContent isVisible={knowledgeVisible}>
                <KnowledgeHubFooterMenu />
              </FadeContent>
            </DropWrapp>            
          </div>
        </MobileFooter>
        <div className="container">
          <MobileInfo>
            <div className="address">
              <strong>Repair Facilities Locations</strong>
              <IconMenuItem>
                <span className="icon"><MapPointer /></span>
                <span className="text">101 Technology Lane. Mt. Airy, NC 27030</span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><MapPointer /></span>
                <span className="text">2875 N. Berkeley Lake Rd, Suite 1 Duluth GA 30096</span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><MapPointer /></span>
                <span className="text">101 Memorial Drive Suite 103 Chattanooga, TN, 37415</span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><PhoneIcon /></span>
                <span className="text"><a href="tel:8663861001">866-386-1001</a></span>
              </IconMenuItem>
              <IconMenuItem>
                <span className="icon"><EmailIcon /></span>
                <span className="text"><a href="mailto:sales@aesintl.com">sales@aesintl.com</a></span>
              </IconMenuItem>
            </div>
            <div className="social">
              <strong>Connect with us</strong>
              <Social />
            </div>
          </MobileInfo>
        </div>
        <Divider />
        <div className="container">
          <FooterBottom>
            <Brands>
              <BrandIeam>
                <StaticImage
                  src="../../images/amtivo.png"
                  alt="amtivo"
                  placeholder="blurred"
                />
              </BrandIeam>
              <BrandIeam imgOpacity="0.6">
                <StaticImage
                  src="../../images/anab.png"
                  alt="anab"
                  placeholder="blurred"
                />
              </BrandIeam>
              <BrandIeam>
                <StaticImage
                  src="../../images/BBB.png"
                  alt="BBB"
                  placeholder="blurred"
                />
              </BrandIeam>
              <BrandIeam>
                <StaticImage
                  src="../../images/EASA.png"
                  alt="EASA"
                  placeholder="blurred"
                />
              </BrandIeam>              
            </Brands>
            <CopyRight>© {new Date().getFullYear()} AES Electronic Services.</CopyRight>
          </FooterBottom>
        </div>
      </Wrap>
    )
  }
}

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer